// extracted by mini-css-extract-plugin
export default {"wrapper":"ColorPickerPopup_wrapper__-UE65"};